
import { defineComponent, PropType } from "vue";

import { NCheckbox, NCheckboxGroup, NFormItem, NSpace } from "naive-ui";

import { useModelValue } from "@/composables/use-model-value";

import { Attribute } from "@/models/tile.model";

export default defineComponent({
  name: "CheckboxGroupElement",

  props: {
    modelValue: Array,

    attribute: {
      type: Object as PropType<Attribute>,
      required: true,
    },
  },

  components: {
    NCheckbox,
    NCheckboxGroup,
    NFormItem,
    NSpace,
  },

  setup(props, context) {
    const localValue = useModelValue(props, context.emit);

    return {
      localValue,
    };
  },
});
